// src/plugins/sdk/useDisputes.ts — permission-checked disputes access.
import { useEffect, useState, useCallback } from 'react';
import { usePluginId } from './PluginContext';
import { requirePermission } from '../permissions';
import { supabase } from '../../supabase';
import { useSession } from '../../auth/hooks';
import { createDispute } from '../../disputes/service';
export function useDisputes() {
    const pluginId = usePluginId();
    requirePermission(pluginId, 'read:disputes');
    const { user } = useSession();
    const [orgId, setOrgId] = useState(null);
    const [rows, setRows] = useState(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (!user)
            return;
        supabase.from('memberships').select('org_id').eq('user_id', user.id).limit(1).maybeSingle()
            .then(({ data }) => setOrgId((data?.org_id) ?? null));
    }, [user]);
    const refresh = useCallback(async () => {
        if (!orgId)
            return;
        const { data, error: err } = await supabase.from('disputes').select('*').eq('org_id', orgId)
            .order('updated_at', { ascending: false });
        if (err) {
            setError(err.message);
            return;
        }
        setRows((data ?? []));
    }, [orgId]);
    useEffect(() => { void refresh(); }, [refresh]);
    return { disputes: rows, orgId, error, refresh };
}
/** Requires `write:disputes` — throws PluginPermissionError otherwise. */
export function useCreateDispute() {
    const pluginId = usePluginId();
    return async (params) => {
        requirePermission(pluginId, 'write:disputes');
        return createDispute(params);
    };
}
